import MapPermissionsMixin from './MapPermissionsMixin';
import Point from 'ol/geom/Point';
import GeoJSON from 'ol/format/GeoJSON';
import { fromLonLat } from 'ol/proj';
import { isArray } from '@config/utils';

let map = {};

export default {
    mixins: [
        MapPermissionsMixin,
    ],
    data() {
        return {
            queryParams: {
                code: null,
                loc: null,
            }
        }
    },
    mounted() {
        let query = this.$route.query;
        if(query){
            let params = {};
            Object.entries(query).forEach(([key, value]) => {
                let decodedKey = decodeURIComponent(key);
                let decodedValue = decodeURIComponent(value);
                params[decodedKey] = decodedValue.split(',').map(item => item.trim());
            });
            this.queryParams = Object.assign(this.queryParams, params);
        }
    },
    created() {
        this.$eventBus.listen(this.moduleCode, `map.initialized-${this.mapId}`, this._onMapInitialized);
        this.$eventBus.listen(this.moduleCode, `map.loaddata-${this.mapId}`, this._onLoadDataMap);
    },
    beforeDestroy() {
        this.$eventBus.remove(this.moduleCode, `map.loaddata-${this.mapId}`, this._onLoadDataMap);
        this.$eventBus.remove(this.moduleCode, `map.initialized-${this.mapId}`, this._onMapInitialized);
    },
    // async beforeRouteEnter (to, from, next) {
    //     next();
    // },
    async beforeRouteUpdate (to, from, next) {
        this.destroyMapObject();
        next();
    },
    async beforeRouteLeave (to, from, next) {
        this.destroyMapObject();
        next();
    },
    computed: {
        moduleId() {
            return this.moduleInternalCode ?? this.moduleCode;
        },
        panelId(){
            return this.pageID || this.idPanel;
        },
        mapId() {
            return this.$root.$helper.global.getMapId(this.moduleId);
        },
        module() {
            return this.moduleId ? this.$store.getters.getModule(this.moduleId) : {};
        },
        panel() {
            return this.panelId ? this.$store.getters.getPanel(this.moduleId, this.panelId) : {};
        },
        panels() {
            return this.moduleId ? this.$store.getters.getPanels(this.moduleId) : {};
        },
        mapPanels() {
            return this.$store.getters[`${this.moduleId}/getMapPanels`];
        },
        locationParam() {
            // map location in WGS84
            return this.queryParams.loc && isArray(this.queryParams.loc) && this.queryParams.loc.length == 2 ? this.queryParams.loc : null;
        }
    },
    methods: {
        updatePanel(params) {
            this.$store.dispatch(`${this.moduleCode}/setPanel`, params);
        },
        openPanel(params) {
            this.$store.dispatch(`${this.moduleCode}/openPanel`, params);
        },
        closePanel(params) {
            this.$store.dispatch(`${this.moduleCode}/closePanel`, params);
        },
        togglePanel(params) {
            this.$store.dispatch(`${this.moduleCode}/togglePanel`, params);
        },
        updateStatePanels(params) {
            this.$store.dispatch(`${this.moduleCode}/statePanels`, params);
        },
        getMapObject: function() {
            return map[this.mapId] || null;
        },
        destroyMapObject: function() {
            let _id = this.mapId;
            if(_id) {
                let _map = map[_id];
                if(_map) _map.destroyMap();
                map[_id] = null;
                delete map[_id];
            }
        },
        openMapPanel(panel, exclusive=true) {
            this.openPanel(panel);
        },
        toggleMapPanel(panel) {
            this.togglePanel(panel);
        },
        closeMapPanel(panel) {
            this.closePanel(panel);
        },
        closeAllMapPanel: function(except = null) {
            let panels = this.mapPanels;
            for (let key in panels) {
                if(except != key && panels[key].show){
                    this.closeMapPanel(key);
                }
            }
        },
        _onMapInitialized: function(data) {
            map[data.id] = data.map;
        },
        async _onLoadDataMap(data) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        let _id = data.id;
                        let _map = data.map;
                        const dispatchMapLoaded = (data={}) => {
                            const _default = {'id': _id, 'map': _map};
                            data = {..._default, ...data};
                            this.onMapLoaded(data);
                            this.$eventBus.publish(this.moduleCode, 'map.loaded', data);
                            this.$eventBus.publish(this.moduleCode, `${_id}.loaded`, data);
                        };

                        let url = this.url?.getMapFeatures;
                        if(url){
                            let options = {params: {}};
                            if(data){
                                if(data.queryParams){
                                    options.params = data.queryParams;
                                }
                            }

                            await this.$http.get(url, options)
                            .then(res => {
                                if (this.createFeatures && typeof this.createFeatures === 'function') {
                                    this.createFeatures(_map, res.data, true)
                                    .then((data)=> {
                                        dispatchMapLoaded(data);
                                    });
                                }
                            })
                            .catch(error => {
                                this.showHttpError(error);
                            })
                        }else{
                            dispatchMapLoaded();
                        }
                        resolve();
                    } catch (err) {
                        reject(err)
                    }
                })()
            });
        },
        onMapLoaded: function(data) {
            // Zoom to map location in WGS84!
            if(this.locationParam && this.locationParam.length==2) {
                const _map = data.map;
                if(_map) {
                    let lat = this.locationParam[0];
                    let lng = this.locationParam[1];
                    let geom = fromLonLat([lng, lat], _map.getProjection());
                    if(geom) {
                        let data = {geom: (new GeoJSON()).writeGeometry(new Point([geom[0], geom[1]]))};
                        _map.drawTemporaryFeature({data});
                    }
                }
            }
        },
    },
}